export default __webpack_public_path__ + "static/media/wpsbox.b6442e49.png";